import React from 'react';
import { SearchBar } from '../components/SearchBar';
import { FilterPanel } from '../components/FilterPanel';
import { RecipeList } from '../components/RecipeList';

/**
 * Search Page Component
 * 
 * Features:
 * - Advanced recipe search functionality
 * - Filter and sort options
 * - Search history and suggestions
 * - iOS-optimized search interface
 */
export const SearchPage: React.FC = () => {
  return (
      <div className="search-page overflow-x-hidden w-full">
        <div style={{ backgroundColor: 'yellow', padding: '10px', fontWeight: 'bold' }}>
          THIS IS THE SEARCH PAGE - TESTING
        </div>
        <div className="search-header mb-6">
          <SearchBar 
            placeholder="Search recipes, ingredients..."
            autoFocus={true}
            onSearch={async (_query: string) => {
              // Searching for query
              // TODO: Implement actual search functionality
              return { 
                results: [], 
                totalCount: 0, 
                hasMore: false
              };
            }}
          />
          <FilterPanel 
            className="mt-4" 
            filters={{ categories: [], difficulties: [], timeRanges: [] }}
            onFiltersChange={() => {}}
          />
        </div>
        
        <div className="search-results overflow-x-hidden w-full">
          <RecipeList />
        </div>
      </div>
  );
};

export default SearchPage;